import './GeneratePage.css';
import './ChosenColor.jsx'
import SideBar from '../../SideBar.jsx';
import PaletteGenerator from './PaletteGenerator.jsx';
import AccountWidget from '../../AccountWidget.jsx';
import LoginModal from "../../LoginModal.jsx";
import { useState } from 'react';
import { Helmet } from "react-helmet-async";

function GeneratePage({username, refreshUser, hasPalette, hasPrompt, logout, urltag}) {
  const [showLogin, setShowLogin] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  function showLoginModal() {
    setShowLogin(true);
  }
  const canonicalUrl = `https://palettemuse.org/generate/${urltag}`;
  return(
    <>
      <Helmet>
            <title>Art Ideas and Color Palettes Generator – Palette Muse</title>
            <meta name="description" content="Generate unique ideas and color palettes to improve your art skills. Customize the generation process and save ideas that you like!" />
            <link rel="canonical" href={canonicalUrl}/>
            <script type="application/ld+json">
              {JSON.stringify({
                "@context": "https://schema.org",
                "@type": "WebPage",
                "name": `Palette Muse Generator`,
                "url": canonicalUrl,
              })}
            </script>
      </Helmet>
      <div className='main'>
        <SideBar loggedIn={username != null} loginFunc={() => setShowLogin(true)} isOpen={sidebarOpen} onToggle={setSidebarOpen}></SideBar>
        <PaletteGenerator hasPalette={hasPalette} hasPrompt={hasPrompt} showLoginModal={showLoginModal} onMenuToggle={() => setSidebarOpen(!sidebarOpen)}></PaletteGenerator>
        <div>
          {username == null ?
            <AccountWidget username={username} onClick={showLoginModal} logout={logout}></AccountWidget> : 
            <AccountWidget username={username} logout={logout}></AccountWidget>
          }
        </div>
        <LoginModal isOpen={showLogin} onClose={() => setShowLogin(false)} refetch={refreshUser} />
      </div>
    </>
  );
}

export default GeneratePage;